import { Injectable } from '@angular/core';
import { CartGroup, getGATrackingItem } from '@app/model/cart.model';

const GTM_ECOMMERCE_EVENT_NAME = 'ecommerce';

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {

    constructor() { }

    /**
   * Wrapper for the global window.dataLayer push method of Google Tag Manager
   * @param params
   */
    private static push(params: any) {
        (window as any).dataLayer =  (window as any).dataLayer || [];
        (window as any).dataLayer.push(params);
    }

    trackTransaction(transactionId: string, email: string, cartAmount: number, groups: CartGroup[]) {
        GoogleAnalyticsService.push({
            'event': GTM_ECOMMERCE_EVENT_NAME,
            'transactionId': transactionId,
            'transactionAffiliation': email,
            'transactionTotal': cartAmount,
            'transactionProducts': this.getTransactionProducts(groups)
        });
    }

    private getTransactionProducts(groups: CartGroup[]) {
        const trackingItems = [];
        for (const group of groups) {
            for (const item of group.items) {
                const trackingItem = getGATrackingItem(item);
                if (trackingItem.hasOwnProperty('sku')) {
                    // this item might be added more than once
                    const existingTrackingItem = trackingItems.find(ti => ti.hasOwnProperty('sku') && ti.sku === trackingItem.sku);
                    if (!!existingTrackingItem) {
                        // same item; increment quantity instead of adding
                        existingTrackingItem.quantity += trackingItem.quantity;
                        continue;
                    }
                }
                trackingItems.push(trackingItem);
            }
        }

        return trackingItems;
    }
}
